export default __webpack_public_path__ + "static/media/404.995e5c15.gif";